import type { ProductCardProps, ProductCardScopedProps } from '../../types'
import * as C from './card.styles'

const Card = (props: ProductCardProps) => {
  const { children, __scopeProductCard, testID, id, ...rest } =
    props as ProductCardScopedProps<ProductCardProps>
  return (
    <C.Root id={id} testID={testID} {...rest}>
      {children}
    </C.Root>
  )
}

export { Card }
